<template>
  <div class="nutrients-table" v-if="stageInfo && stageInfo.length > 0">
    <div class="title">
      <!-- {{$ml.get(`Current Application vs. Requirements (kg)`)}} -->
      {{$ml.get('Current Application vs. Requirements, ')}} {{$ml.get($store.getters['unit/getLabel']('kg'))}}
      <info-tip :title="$ml.get(`here you can see in detail the fulfilmentof the required nutrients for each growth stage`)"/>
      <!-- <info-tip :title="$ml.get(`here you can see in detail the fulfilmentof the required nutrients for each growth stage`)"/> -->
    </div>
    <div class="nut-content" :class="{blur : (!$store.getters['user/data'].subsPlan)}">
      <app-btn to="/dashboard/plans" class="go-to-plans" v-if="!$store.getters['user/data'].subsPlan">{{$ml.get(`Get the full access to the software`)}}</app-btn>

      <div class="nut-list">
        <div class="item"></div>
        <div class="item"></div>
        <div class="item" v-for="(nut, i) in nutElems" :key="i">
          <template v-if="nut == 'CL'">
            <div class="capitalize">{{nut}}</div>
          </template>
          <template v-else>
            <!-- {{nut}} -->
            {{['NO3', 'NH4', 'NH2'].includes(nut) ? 'N-' + nut : nut}}
          </template>
        </div>
      </div>
      <div>
        <carousel :pageCustom="pageCustom">
          <template v-for="(item, i) in stageInfo">
            <div class="row" :key="i">
              <div>
                  <div class="item">
                      {{$ml.get(item.name)}}
                  </div>
                <div class="item">
                  <span>
                    {{$ml.get(`Actual Requirement,`)}}
                    <template v-if="$store.getters['program/data'].type == 'soil-based'">{{$ml.get($store.getters['unit/getLabel']('kg'))}}</template>
                    <template v-else>ppm</template>
                  </span>
                  <span>
                    {{$ml.get(`Current Application,`)}}
                    <template v-if="$store.getters['program/data'].type == 'soil-based'">{{$ml.get($store.getters['unit/getLabel']('kg'))}}</template>
                    <template v-else>ppm</template>
                  </span>
                  <span>
                    {{$ml.get(`Full Requirement`)}}
                  </span>
                </div>
              </div>
              <div v-for="(nut, j) in nutElems" :key="j">
                <div class="item" v-if="item.nutrients[nut]">
                  <span>
                    <!-- {{item.nutrients[nut].needed}} -->
                    <template v-if="$store.getters['program/data'].type == 'soil-based'">{{$store.getters['unit/convert']('kg', item.nutrients[nut].needed)}}</template>
                    <template v-else>{{item.nutrients[nut].needed}}</template>

                    <template v-if="$store.getters['program/data'].type == 'soil-based'"> {{$ml.get($store.getters['unit/getLabel']('kg'))}}</template>
                    <template v-else>ppm</template>
                  </span>
                  <span>
                    <!-- {{item.nutrients[nut].fert}} -->
                    <template v-if="$store.getters['program/data'].type == 'soil-based'">{{$store.getters['unit/convert']('kg', item.nutrients[nut].fert)}}</template>
                    <template v-else>{{item.nutrients[nut].fert}}</template>

                    <template v-if="$store.getters['program/data'].type == 'soil-based'"> {{$ml.get($store.getters['unit/getLabel']('kg'))}}</template>
                    <template v-else>ppm</template>
                  </span>
                  <span :class="item.nutrients[nut].accuracy < 50 ? 'red' :
                    item.nutrients[nut].accuracy < 70 ? 'yellow' : 'green'"
                  >
                    <template v-if="item.nutrients[nut].needed == 0"><div style="color:#2c3e50;">-</div></template>
                    <template v-else-if="item.nutrients[nut].accuracy > 120">
                      <div style="color:$mainGreen;">{{item.nutrients[nut].accuracy}}%</div>
                    </template>
                    <template v-else>{{item.nutrients[nut].accuracy}}%</template>
                  </span>
                </div>
              </div>
              <!-- {{item.ratios}} -->
              <div class="ratios" v-if="item.ratios">
                <div>{{ $ml.get(`Ratios:`)  }}</div>

                <div v-for="(value, name, index) in item.ratios">
                  <b>{{ name }}</b>
                  {{ value }}
                </div>


              </div>

            </div>
          </template>
        </carousel>
      </div>
    </div>
    <!-- {{ stageInfo }} -->
  </div>

</template>

<script>
import Carousel from '@/components/common/carousel/Carousel';

export default {
  props: {
    stageInfo: Array,
    nutElems: Array
  },
  components: {
    Carousel
  },
  data() {
    return {
      pageCustom: [
        [0, 1],
        [1300, 2],
        [1500, 3]
      ]
    }
  },
}
</script>

<style lang="scss" scoped>

.nutrients-table {
  padding-top: 50px;
  display: flex;
  flex-direction: column;

  .title {
    padding-bottom: 15px;
    font-size: 22px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .item {
    height: 64px;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .nut-content {
    display: flex;
    flex-direction: row;
    align-items: stretch;

    .nut-list {
      display: flex;
      flex-direction: column;
      align-items: stretch;

      .item {
        font-size: 13px;
        width: 80px;
        font-weight: bold;
      }
    }

    > div:last-child {
      width: calc(100% - 80px);
    }

    .row {
      width: 100%;

      > div {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        &.ratios {
          align-items: flex-start;
          margin-top: 16px;
          div {
            margin-bottom: 8px;
          }
        }
        .item {
          width: 100%;
          justify-content: space-around;
          font-size: 16px;
          font-weight: bold;
          font-family: Roboto;


          span {
            text-align: center;
            padding: 0 5px;
            display: block;
            width: 33.3%;
            font-size: 16px;
            font-weight: 400;
            font-family: Roboto;

            &.green {
              color: $mainGreen;
              font-weight: 500;
            }
            &.red {
              font-weight: 500;
              color: #E8282F;
            }
            &.yellow {
              font-weight: 500;
              color: #F2B14E;
            }
          }
        }

        &:first-child {
          span {
            font-size: 11px;
          }
        }
      }
    }
  }

  @media (max-width:768px) {
    .nut-content {
      .nut-list {
        .item {
          width: 40px;
        }
      }
      > div:last-child {
        flex-grow: 1;
      }
    }
  }
}

</style>
